// extracted by mini-css-extract-plugin
module.exports = {"Container":"ApplicationShellView__Container___2fAZ2","pageContent":"ApplicationShellView__pageContent___3JrWZ"};